import { observer } from 'mobx-react';
import { StepTitle } from './stepTitle';
import { TextField, DateField } from '@roc/ui';
import { FormStore } from '@roc/feature-app-core';
import { Box, Grid } from '@material-ui/core';
import { OneToolCardBorder } from '../fixFlip/oneToolCard';
import { isNotBlank } from '@roc/feature-utils';

export const ClosingAttorney = observer(({ store }: { store: FormStore }) => {
  const fieldName = 'preferredClosingAttorney';
  const field = store.form.fields[fieldName];
  return (
    <TextField
      label="Closing Attorney"
      name={fieldName}
      testId={fieldName}
      value={field.value}
      standaloneLabel
      onChange={e => store.onFieldChange(fieldName, e.target.value)}
      variant="outlined"
      fullWidth
      error={!store.form.meta.isValid && isNotBlank(field.error)}
      helperText={!store.form.meta.isValid && field.error}
    />
  );
});

export const TitleCompany = observer(({ store }: { store: FormStore }) => {
  const fieldName = 'preferredTitle';
  const field = store.form.fields[fieldName];
  return (
    <TextField
      label="Title Company"
      name={fieldName}
      testId={fieldName}
      value={field.value}
      standaloneLabel
      onChange={e => store.onFieldChange(fieldName, e.target.value)}
      variant="outlined"
      fullWidth
      error={!store.form.meta.isValid && isNotBlank(field.error)}
      helperText={!store.form.meta.isValid && field.error}
    />
  );
});

export const ClosingDate = observer(({ store }: { store: FormStore }) => {
  const formFields = store.form.fields;
  return (
    <DateField
      inputVariant="outlined"
      testId="requestedClosingDate"
      format="MM/dd/yyyy"
      standaloneLabel
      label="Requested Closing Date"
      value={formFields.requestedClosingDate.value}
      error={isNotBlank(formFields.requestedClosingDate.error)}
      helperText={formFields.requestedClosingDate.error}
      onChange={date => store.onFieldChange('requestedClosingDate', date)}
      disablePast
      fullWidth
    />
  );
});

export const ClosingDetailsCard = observer(({ formStore }: { formStore: FormStore }) => {
  return (
    <>
      <Grid item xs={12}>
        <StepTitle
          title={'Closing Details'}
          subtitle={
            'Please provide the information for the closing attorney and title company.'
          }
        />
      </Grid>
      <Grid item xs={12}>
        <OneToolCardBorder>
          <Box px={4}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <ClosingAttorney store={formStore} />
              </Grid>
              <Grid item xs={6}>
                <TitleCompany store={formStore} />
              </Grid>
              <Grid item xs={6}>
                <ClosingDate store={formStore} />
              </Grid>
            </Grid>
          </Box>
        </OneToolCardBorder>
      </Grid>
    </>
  );
});
